module.exports = __webpack_public_path__ + "img/icons.52800983.svg";